import { apiGet, apiPatch } from './client';
import type { AlertType, AlertTypeBatchRequest } from '../types/AlertType';

export function getAlertTypes(): Promise<AlertType[]> {
  return apiGet<AlertType[]>('/api/alert-types');
}

export function saveAlertTypesBatch(
  added: AlertType[],
  modified: AlertType[],
  deletedIds: number[],
): Promise<AlertType[]> {
  return apiPatch<AlertTypeBatchRequest, AlertType[]>('/api/alert-types/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
